module.exports = __webpack_public_path__ + "static/media/ajout-recherche.399d6184.png";